import { render, staticRenderFns } from "./MasterTemplate.vue?vue&type=template&id=5e2433fd"
import script from "./MasterTemplate.vue?vue&type=script&lang=js"
export * from "./MasterTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports